import NotFound from "src/components/feature/NotFound";

const PageNotFound = () => {
  return <NotFound />;
};

export default PageNotFound;
